export var ChainId;
(function (ChainId) {
    ChainId["BITCOIN_MAINNET"] = "bitcoin:mainnet";
    ChainId["BITCOIN_TESTNET"] = "bitcoin:testnet";
    ChainId["BITCOIN_TESTNET4"] = "bitcoin:testnet4";
    ChainId["BITCOIN_SIGNET"] = "bitcoin:signet";
    ChainId["FRACTAL_BITCOIN_MAINNET"] = "fractal:mainnet";
    ChainId["FRACTAL_BITCOIN_TESTNET"] = "fractal:testnet";
    ChainId["STACKS_MAINNET"] = "stacks:mainnet";
    ChainId["STACKS_TESTNET"] = "stacks:testnet";
})(ChainId || (ChainId = {}));
export var Network;
(function (Network) {
    Network["Mainnet"] = "mainnet";
    Network["Testnet"] = "testnet";
    Network["Regtest"] = "regtest";
})(Network || (Network = {}));
//# sourceMappingURL=chain.js.map